import LoginContainer from "../components/atomic/molecular/LoginContainer";
import VerificationCode from "../components/atomic/organisms/VerificationCode";

const SignUpConform = () => {
  const handleAfterConform = () => {
    alert("登録が完了しました。ログインしてください");
  };

  return (
    <LoginContainer label={"確認コード入力"}>
      <VerificationCode
        handleAfterConform={handleAfterConform}
        buttonId={"cta_amb_mail"}
      />
    </LoginContainer>
  );
};

export default SignUpConform;
